module.exports = __webpack_public_path__ + "img/t3-15.4a176d93.png";